import React, { useState, useEffect } from "react";
import FAQItem from "./faqItem";

interface FAQ {
  question: string;
  answer: string;
  text_size: string;
  video_url: string;
}
interface FAQSectionProps {
  heading: string;
  faqItems: FAQ[];
}

export default function FAQSection({ heading, faqItems }: FAQSectionProps) {
  const [faqHeading, setFAQHeading] = useState("");
  const [faqs, setFAQS] = useState<FAQ[]>([]);

  useEffect(() => {
    setFAQHeading(heading);
    setFAQS(faqItems);
  }, []);

  return (
    <div>
      {faqs.length > 0 && (
        <div className="flex justify-center text-center bg-white pt-6 pb-12 sm:!py-16">
          <div className="w-full sm:w-[60%]">
            <h3 className="h3 mb-6 sm:mb-7">{faqHeading}</h3>
            <div className="flex justify-center">
              <div className="flex justify-center">
                <div className="text-left w-[90%]">
                  <hr />
                  {faqs.map((item, index) => (
                    <div key={`faq_${index}`}>
                      <FAQItem
                        question={item["question"]}
                        answer={item["answer"]}
                      />
                      <hr />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
